import { useState, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";
import Dashboard from "./scenes/dashboard";
import Team from "./scenes/team";
import Influencers from "./scenes/Influencer";
import Invoices from "./scenes/invoices";
import Bar from "./scenes/bar";
import Profile from "./scenes/profile";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import FAQ from "./scenes/faq";
import Login from "./scenes/login/Login";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Register from "./scenes/login/Register";
import CompleteRegistration from "./scenes/login/CompleteRegister";
import NotFound from "./components/NotFound";
import ForgotPassword from "./scenes/login/ForgotPassword";
import ResetPassword from "./scenes/login/ResetPassword";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const navigate = useNavigate();

  // Authentication state
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );

  // Handle login
  const handleLogin = (userData, token) => {
    setIsAuthenticated(true);
    setUser(userData);
    localStorage.setItem("token", token); // Save token in localStorage
    localStorage.setItem("user", JSON.stringify(userData)); // Save user data
  };

  // Handle logout
  const handleLogout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/"); // Redirect to login page after logout
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");
    if (storedUser && storedToken) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
  }, []);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div className="app">
          {isAuthenticated && <Sidebar  isSidebar={isSidebar} />}
          <main className="content">
            {isAuthenticated && (
              <Topbar onLogout={handleLogout} setIsSidebar={setIsSidebar} />
            )}
            <Routes>
              {/* Route for the login page */}
              <Route
                path="/"
                element={
                  isAuthenticated ? (
                    <Navigate to="/dashboard" />
                  ) : (
                    <Login
                      onLogin={handleLogin}
                      toggleColorMode={colorMode.toggleColorMode}
                    />
                  )
                }
              />
              <Route path="/login" element={<Login onLogin={handleLogin} />} />
              <Route
                path="/register"
                element={
                  <Register toggleColorMode={colorMode.toggleColorMode} />
                }
              />
              <Route
                path="/complete-registration"
                element={
                  <CompleteRegistration
                    toggleColorMode={colorMode.toggleColorMode}
                  />
                }
              />
              <Route
                path="/forgot-password"
                element={
                  <ForgotPassword
                    toggleColorMode={colorMode.toggleColorMode}
                  />
                }
              />
              <Route
                path="/reset-password"
                element={
                  <ResetPassword
                    toggleColorMode={colorMode.toggleColorMode}
                  />
                }
              />
              {/* Protected route for Dashboard */}
              <Route
                path="/dashboard"
                element={isAuthenticated ? <Dashboard /> : <Navigate to="/" />}
              />
              <Route
                path="/role"
                element={isAuthenticated ? <Team /> : <Navigate to="/" />}
              />
              <Route
                path="/influencer"
                element={
                  isAuthenticated ? <Influencers /> : <Navigate to="/" />
                }
              />
              <Route
                path="upload&export"
                element={isAuthenticated ? <Invoices /> : <Navigate to="/" />}
              />
              <Route
                path="/bar"
                element={isAuthenticated ? <Bar /> : <Navigate to="/" />}
              />
              <Route
                path="/pie"
                element={isAuthenticated ? <Pie /> : <Navigate to="/" />}
              />
              <Route
                path="/profile"
                element={
                  isAuthenticated ? (
                    <Profile user={user} onLogout={handleLogout} />
                  ) : (
                    <Navigate to="/" />
                  )
                }
              />
              <Route
                path="/line"
                element={isAuthenticated ? <Line /> : <Navigate to="/" />}
              />
              <Route
                path="/faq"
                element={isAuthenticated ? <FAQ /> : <Navigate to="/" />}
              />

              <Route
                path="/geography"
                element={isAuthenticated ? <Geography /> : <Navigate to="/" />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
        </div>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;

